import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';
import Form from "../models/Form";

// const fb = require('@/firebase/config.js');

Vue.use(Vuex)

// const frm = {
//   surname: '',
//   email: '',
//   gender: '',
//   country: '',
//   confirmPrivacy: false,
//   confirmAge: false,
// }


export const store = new Vuex.Store({
  modules: {
    user
  },
  state: {
    currentStep: 0,
    form: new Form(),
    question: null,
    recordedVideo: null,
    browserVideoRecordingSupport: true,
    isMobile: false,
  },
  mutations: {
    setForm(state, payload) {
      state.form = payload;
    },
    setQuestion(state, payload) {
      state.question = payload;
    },
    setVideoFile(state, payload) {
      state.recordedVideo = payload;
    },
    clearAll(state) {
      state.form = new Form();    // TODO: init value
      state.recordedVideo = null;
      state.question = null;
    },
    setBrowserVideoRecordingSupport(state, payload) {
      state.browserVideoRecordingSupport = payload;
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    updateForm(state, payload) {
      Object.assign(state.form, payload);
    },
  },
  actions: {
    clearAll({commit}) {
      commit('clearAll');
    }
  }
})
